import React from "react";
import Reveal from "@/components/Reveal";
import { ImageIcon } from "lucide-react";

export default function Gallery() {
  return (
    <section id="galeria" data-testid="gallery-section" className="relative py-24 md:py-36 bg-[#080808]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <Reveal className="lg:col-span-7">
            <p className="overline mb-6">Galeria realizacji</p>
            <h2 className="section-title text-white text-4xl md:text-6xl leading-[1.04]">
              Detale, które
              <br />
              <span className="italic text-neutral-300">mówią same za siebie</span>.
            </h2>
          </Reveal>
          <Reveal delay={150} className="lg:col-span-5 lg:pt-6">
            <p className="text-neutral-400 leading-relaxed">
              Aktualnie przygotowujemy zestawienie naszych najnowszych realizacji. Wkrótce znajdą
              się tu zdjęcia nagrobków, schodów, parapetów, blatów i elementów architektonicznych
              wykonanych w naszej pracowni.
            </p>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div
            data-testid="gallery-coming-soon"
            className="hairline bg-[#0a0a0a] grain min-h-[420px] md:min-h-[520px] flex flex-col items-center justify-center text-center px-6 py-16"
          >
            <ImageIcon size={42} strokeWidth={0.8} className="text-[var(--accent)] mb-8" />
            <p className="overline mb-5">Galeria wkrótce</p>
            <h3 className="section-title text-white text-3xl md:text-5xl max-w-2xl leading-tight">
              Przygotowujemy dla Państwa
              <br />
              <span className="italic text-neutral-300">wybór naszych realizacji</span>.
            </h3>
            <p className="mt-8 max-w-xl text-neutral-400 text-sm md:text-base leading-relaxed">
              Do tego czasu zapraszamy do kontaktu — chętnie pokażemy zdjęcia konkretnych prac
              dopasowanych do Państwa zapytania.
            </p>

            <a
              href="#kontakt"
              data-testid="gallery-contact-cta"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById("kontakt");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-ghost mt-10"
            >
              Skontaktuj się z nami
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
